import Vue from 'vue';
import Router from 'vue-router';
import { authService } from './services/auth-service';
import { isNull } from './shared/utils/utils';
import Component from 'vue-class-component';

Vue.use(Router);

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

const router: Router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/home/home.vue'),
            meta: {
                auth: true,
            },
        },
        {
            path: '/login',
            component: () => import('./views/login/login.vue'),
            meta: {
                layout: 'unauthorized',
                title: 'Login',
            },
        },        
        {
            path: '/mailwizzes',
            name: 'mailwizzes',
            component: () => import('./views/mailwizzes/mailwizzes.vue'),
            meta: {
                auth: true,
            },
        },
        {
            path: '/testcases',
            name: 'testcases',
            component: () => import('./views/testcases/testcases.vue'),
            meta: {
                auth: true,
                mailWizzDependent: true
            },
        },
        {
            path: '/testcases/new',
            name: 'new-testcase',
            props: (route) => ({ copyFromId: route.query.copyFromId }),
            component: () => import('./views/create-testcase/create-testcase.vue'),
            meta: {
                auth: true,
                mailWizzDependent: true
            },
        },
        {
            path: '/testcases/:id',
            name: 'view-testcase',
            props: true,
            component: () => import('./views/view-testcase/view-testcase.vue'),
            meta: {
                auth: true
            },
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./views/users/users.vue'),
            meta: {
                auth: true,
            },
        },
        {
            path: '/users/new',
            name: 'new-user',
            props: (route) => ({ copyFromId: route.query.copyFromId }),
            component: () => import('./views/users/user-create.vue'),
            meta: {
                auth: true,
            },
        },
        {
            path: '/users/:id',
            name: 'edit-user',
            props: true,
            component: () => import('./views/users/user-edit.vue'),
            meta: {
                auth: true
            },
        },
        {
            path: '/settings',
            name: 'settings',
            props: true,
            component: () => import('./views/settings/settings.vue'),
            meta: {
                auth: true
            },
        },
        {
            path: '/tracking-domains',
            name: 'tracking-domains',
            props: true,
            component: () => import('./views/tracking-domains/tracking-domains.vue'),
            meta: {
                auth: true,
                mailWizzDependent: true
            }
        }]
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        // not authenticated
        if (!authService.isAuthenticated) {
            return next({
                path: '/login',
                query: { redirectUrl: to.fullPath },
            });
        }

        // must change password
        if (authService.user.mustChangePassword) {
            return next({ path: '/account/change-password' });
        }

        if (isNull(to.meta.applicationId)) {
            return next();
        }
    }

    next();
});

export default router;
